<template>
  <div class="img-swiper-mask" v-show="visible">
    <div class="alert">
      <div class="title">Screenshots</div>
      <div class="pic-content">
        <div class="transpic">
          <swiper :options="swiperOption" ref="mySwiper" class="swiper-inner">
            <!-- slides -->
            <swiper-slide v-for="(item,index) in translist" :key="index">
              <img :src="item" class="swiper-img">
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <img class="close" src="@/assets/close.png" @click="visible = false">
  </div>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  components: {
        swiper,
        swiperSlide
    },
  data() {
    return {
      visible: false,
      translist: [
        require("@/assets/1.png"),
        require("@/assets/2.png"),
        require("@/assets/3.png"),
        require("@/assets/4.png"),
        require("@/assets/5.png"),
      ],
      //轮播图配置
      swiperOption: {
        loop: true,
        notNextTick: true,
        speed: 300,//设置切换速度，默认300
        autoplay: {
        delay: 3000, //自动切换的时间间隔，单位ms
        stopOnLastSlide: false, //当切换到最后一个slide时停止自动切换
        disableOnInteraction: false, //用户操作swiper之后，是否禁止autoplay。
        reverseDirection: false, //开启反向自动轮播。
        waitForTransition: true, //等待过渡完毕。自动切换会在slide过渡完毕后才开始计时。
        },
        // direction : 'vertical',
        grabCursor : true,
        setWrapperSize :true,
        paginationClickable :true,
        // prevButton:'.swiper-button-prev',
        // nextButton:'.swiper-button-next',
        // scrollbar:'.swiper-scrollbar',
        mousewheelControl : true,
        observeParents:true,
        debugger: true,
        // effect : 'coverflow',
        // slidesPerView: 1.3,
        centeredSlides: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 10,
          depth: 200,
          modifier: 2,
          slideShadows: true
        },
        navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
        },
      },
    }
  }
}
</script>
<style lang="scss" scoped>
.img-swiper-mask{
  width: 100%;
  height: 100vh;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  background: rgba($color: #000000, $alpha: 0.8);
  .alert{
    .title{
      width: 100%;
      text-align: center;
      color: #fff;
      font-weight: 900;
      font-size: 22px;
      -webkit-text-stroke: 1px #000;
      margin-bottom: 30px;
    }
    .pic-content{
      width: 300px;
      height: 7rem;
      background-size: 300px 7rem;
      z-index: 0;
      position: relative;
      margin-bottom: 30px;
    }
    .transpic{
      width: 300px;
    }
    .swiper-inner{
      width: 300px;
    }
    .swiper-img{
      width: 300px;
      height: 7rem;
      position: relative;
    }
  }
  .close{
    cursor: pointer;
    position: absolute;
    right: 200px;
    top: 100px;
    width: 70px;
    height: 70px;
  }
}
@media screen and (max-width: 768px) {
  .img-swiper-mask{
    .close{
      right: 0px;
      top: 540px;
    }
  }
}
</style>